<template>
  <div class='card block-shadow'>
    <div class="card__title"
         v-bind:style="{ background: headerColor }">
      <span v-if="cardOptions.type">
        {{ cardOptions.type }}
      </span>
      <span v-if="cardOptions.type"
            class="hide-480">
        &nbsp;
      </span>
      <span>
        {{ cardOptions.name }}
      </span>
    </div>

    <div class="card__content">
      <div class="card__content__details">
        <div class="details-description">{{ cardOptions.description }}</div>
        <div class="details-prices">
          <div>
            <div class="details-prices__discount-top">{{ cardOptions.costDetails.discount }}</div>
            <div class="details-prices__discount-bottom">знижка</div>
          </div>
          <div>
            <div class="details-prices__old-top">{{ cardOptions.costDetails.oldCost }}</div>
            <div class="details-prices__old-bottom">
              {{ cardOptions.costDetails.unit.currency }}/{{ cardOptions.costDetails.unit.month }}
            </div>
          </div>
          <div class="hide-768">
            <div class="details-prices__cost-top" v-bind:style="{color: accentColor}">{{ cardOptions.costDetails.fullCost }}</div>
            <div class="details-prices__cost-bottom" v-bind:style="{color: accentColor}">
              {{ cardOptions.costDetails.unit.currency }}/{{ cardOptions.costDetails.unit.month }}
            </div>
          </div>
        </div>

        <div class="hide show-768 details-prices__cost-mobile"
             v-bind:style="{color: accentColor}">
          <div class="details-prices__cost-top">{{ cardOptions.costDetails.fullCost }}</div>
          <div class="details-prices__cost-bottom">
            {{ cardOptions.costDetails.unit.currency }}/{{ cardOptions.costDetails.unit.month }}
          </div>
        </div>
      </div>

      <div class="card__content__form">
        <v-form class="content__form" ref="form" lazy-validation>
          <v-text-field
              required
              single-line
              autocomplete="off"
              :rules="modelsRules.nameRules"
              placeholder="Імʼя"
              v-model="models.name">
          </v-text-field>
          <v-text-field
              required
              single-line
              autocomplete="off"
              :rules="modelsRules.phoneRules"
              v-mask="'+38(0##)###-##-##'"
              placeholder="+38(0__)___-__-__"
              v-model="models.phone">
          </v-text-field>
          <v-btn
              small
              class="primary order-consult-button"
              @click="order(models, gaTag)"
              elevation="2">
            Забронювати консультацію
          </v-btn>
        </v-form>
        <div class="card__content__form__undertext" v-if="cardOptions.underText">{{ cardOptions.underText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {phoneValidation} from "../validators/validators";
import Orders from "../services/orders";

export default {
  name: "CardItemHorizontalSimpleWithForm",
  props: [
    'cardOptions',
    'headerColor',
    'accentColor',
    'landingCodename',
    'gaTag'
  ],

  methods: {
    order(formData, gaTag) {
      const self = this
      if (this.$refs.form.validate()) {
        formData.landing_codename = this.$props.landingCodename
        Orders.createOrder(formData).then(function (response) {

          self.$basicDialog.open({text: 'Очікуйте дзвінка оператора'});
          self.$refs.form.reset();
          // send to GoogleAnalytics
          if (gaTag) {
            self.$ga.event('form', gaTag)
          }

        }).catch(function (error) {
          console.log(error)
        });
      }
    }
  },

  data() {
    return {
      models: {
        name: '',
        phone: ''
      },
      modelsRules: {
        nameRules: [
          v => !!v || 'Обовʼязкове поле',
        ],
        phoneRules: [
          v => !!v || 'Обовʼязкове поле',
          v => (v && !!phoneValidation(v)) || 'Невірний формат телефону'
        ],
      }
    }
  }
}
</script>

<style scoped>

.hide {
  display: none;
}

.card {
  width: 100%;
  border-radius: 25px;
  background-color: #f3f3f3;
  overflow: hidden;
}

.card__title {
  height: 65px;
  padding: 0 15px;
  font-weight: 800;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #e76d82;
  line-height: 30px;
  color: #ffffff;
  font-size: 32px;
}

.card__content {
  padding: 30px 20px 30px;
  display: flex;
  flex-direction: row;
}

/* LEFT BLOCK */

.card__content__details {
  width: 50%;
  margin: auto;
  text-align: center;
  padding-bottom: 30px;
}

.details-description {
  color: grey;
  font-size: 26px;
  text-align: center;
}

.details-prices {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  line-height: normal;
  align-items: flex-end;
  padding: 0 40px;
}

.details-prices div {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.details-prices__discount-top,
.details-prices__old-top {
  font-size: 36px;
  color: grey;
}

.details-prices__old-top {
  text-decoration: line-through;
}

.details-prices__discount-bottom,
.details-prices__old-bottom,
.details-prices__cost-bottom {
  color: grey;
  letter-spacing: 1px;
}

.details-prices__cost-top {
  font-size: 54px;
  font-weight: 800;
  letter-spacing: 2px;
  color: red;
}

.details-prices__cost-bottom {
  color: red;
  font-weight: 600;
}

/* RIGHT BLOCK */

.card__content__form {
  width: 50%;
  margin: 0 10px;
  padding: 0 30px 20px;
  border-radius: 25px;
  border: 2px solid #c2c2c2;
}

.content__form {
  text-align: center;
}

.card__content__form__undertext {
  padding-top: 5px;
  font-size: 12px;
  color: grey;
  text-align: center;
}

/* MEDIA */

@media (max-width: 1024px) {
  .details-description {
    font-size: 20px;
  }

  .details-prices {
    padding: 0 10px;
  }

  .details-prices__discount-top,
  .details-prices__old-top {
    font-size: 30px;
  }

  .details-prices__cost-top {
    font-size: 50px;
  }

  .details-prices__cost-bottom {
    font-weight: 500;
  }

  .card__content__form {
    padding: 0 22px 20px;
  }
}

@media (max-width: 768px) {
  .hide-768 {
    display: none !important;
  }

  .show-768 {
    display: inline-block !important;
  }

  .card {
    margin-bottom: 15px;
  }

  .card__content {
    padding: 15px 20px;
    display: flex;
    flex-direction: column;
  }

  .card__content__details {
    padding: 0;
    width: 90%;
  }

  .details-description {
    padding: 15px;
  }

  .details-prices__cost-mobile {
    text-align: center;
    line-height: normal;
    margin-top: 5px;
  }

  .details-prices div {
    flex-direction: row;
    align-items: flex-end;
  }

  .details-prices__discount-bottom,
  .details-prices__old-bottom {
    padding-left: 5px;
  }

  .card__content__form {
    width: auto;
    margin: 15px 30px;
    padding: 10px 30px;
  }

  .order-consult-button {
    height: unset !important;
    margin: 10px 0;
    max-width: 260px;
    width: 100%;
  }

  >>> .order-consult-button .v-btn__content {
    white-space: normal;
    flex: unset;
    padding: 5px 10px;
  }
}

@media (max-width: 400px) {
  .card__title {
    font-size: 24px;
  }

  .card__content__details {
    width: 100%;
  }

  .card__content__form {
    margin: 10px 0;
  }

  .details-prices__discount-bottom,
  .details-prices__old-bottom {
    font-size: 14px;
  }

  .details-prices > div {
    padding: 0 10px;
  }
}
</style>
